import routes from "../common/api-routes";
import {HttpAuthGet, HttpAuthPost} from "../../../../core/services/common/HttpRequestBuilder";

const listAdminProfile = (parameters) => {
    let result = HttpAuthGet(routes.LIST_ADMIN_PROFILE, parameters);
    return result;
}

const addAdminProfile = (payload) => {
    let result = HttpAuthPost(routes.ADD_ADMIN_PROFILE, payload);
    return result;
}

const getProfileTypes = () => {
    let result = HttpAuthGet(routes.GET_PROFILE_TYPES);
    return result;
}

const getIDTypes = () => {
    let result = HttpAuthGet(routes.GET_ID_TYPES);
    return result;
}

const getProfileStatus = () => {
    let result = HttpAuthGet(routes.GET_PROFILE_STATUS);
    return result;
}

const getProfile = () => {
    let result = HttpAuthGet(routes.GET_PROFILE);
    return result;
}

const viewProfile = () => {
    let result = HttpAuthGet(routes.VIEW_PROFILE);

    return result;
}

const viewUserAccount = () => {
    let result = HttpAuthGet(routes.VIEW_USER_ACCOUNT);
    return result;
}

const AdminProfileService = {
    listAdminProfile: listAdminProfile,
    addAdminProfile: addAdminProfile,
    getProfileTypes: getProfileTypes,
    getIDTypes: getIDTypes,
    getProfileStatus: getProfileStatus,
    getProfile: getProfile,
    viewProfile: viewProfile,
    viewUserAccount
}

export default AdminProfileService